<div class="row g-3">
 <!-- Año -->
 <div class="col-6">
    <label class="form-label">Año a reportar</label>
    <select
      class="form-select"
      [(ngModel)]="selectedYear"
      (ngModelChange)="onYearModelChange($event)"
    >
      <option [ngValue]="null" disabled>Seleccione</option>
      <option *ngFor="let year of years" [ngValue]="year">
        {{ year }}
      </option>
    </select>
  </div>

  <!-- Trimestre -->
  <div class="col-6">
    <label class="form-label">Trimestre a reportar</label>
    <select
      class="form-select"
      [(ngModel)]="selectedQuarter"
      (ngModelChange)="onQuarterModelChange($event)"
    >
      <option [ngValue]="null" disabled>Seleccione</option>
      <option *ngFor="let quarter of quarters" [ngValue]="quarter">
        {{ quarter.name }}
      </option>
    </select>
  </div>
</div>